import * as React from "react";
import { getToken } from "@grandvisionhq/auth";
import { Spinner } from "@grandvisionhq/iris-ui";
/* empty css                     */
const withUserToken = (Component) => {
  const displayName = Component.displayName || Component.name || "Component";
  const WithUserToken = (props) => {
    const [userToken, setUserToken] = React.useState();
    const [loading, setLoading] = React.useState(true);
    React.useEffect(() => {
      getToken().then((token) => {
        setUserToken(token);
        setLoading(false);
      }).catch((error) => {
        console.error(error);
        setLoading(false);
      });
    }, []);
    if (loading) {
      return /* @__PURE__ */ React.createElement("div", { className: "with-user-token__loader-wrapper" }, /* @__PURE__ */ React.createElement(Spinner, null));
    }
    if (!userToken) {
      throw new Error("JWT_TOKEN_NOT_FOUND");
    }
    return /* @__PURE__ */ React.createElement(Component, { ...props, userToken });
  };
  WithUserToken.displayName = `WithUserToken(${displayName})`;
  return WithUserToken;
};
export {
  withUserToken
};
//# sourceMappingURL=with-user-token.js.map
